export default "__VITE_ASSET__155e5d65__"